<div class="dropdown">
  <label *ngIf="label">{{label}}</label>
  <button
    nz-button
    nzNoAnimation
    nz-dropdown
    type="button"
    nzTrigger="click"
    (click)="captureClickEvent()"
    (blur)="checkIfFieldHasNotValueAndMarkAsTouched()"
    [nzDropdownMenu]="menu"
    class="dropdown-button"
    [class.danger]="showErrors && control.invalid && control.touched">

    <div>{{placeholder}}</div>
    <img class="arrow-down-icon"
      [class.active]="arrowOpen"
      src="assets/icons/arrow-down.svg" 
      alt="seta de expansão">
  </button>

  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
      <li nz-menu-item class="option-item"
        *ngFor="let option of options" 
        (click)="selectOption(option.id)">
        <span class="dropdown-option">{{option.description}}</span>
      </li>
    </ul>
  </nz-dropdown-menu>

  <app-valid-msg
    [control]="control"
    [hint]="hint"
    [fieldName]="fieldName"
    [showIcon]="showIconError">
  </app-valid-msg>
</div>